import React, { Component } from 'react';
import { Singleton } from '../../js/Singleton';
import { alert } from '../../Images/Images';

export default class AlertMessageVolume extends Component {
  constructor(props) {
    super(props);
    this.language = new Singleton();
    this.hiddeAlertTimer  = null;
    this.hideNotificationTimer = null;
    this.state = {
      hiddeAlert: false,
    }
  }
  componentWillUnmount(){
    clearTimeout(this.hideNotificationTimer);
    clearTimeout(this.hiddeAlertTimer);
  }
  componentDidMount() {
    let _this = this;
    this.hiddeAlertTimer = setTimeout(() => {
      this.setState({
        hiddeAlert: true
      });
      _this.hideAlert()
    }, 5000);
  }
  hideAlert() {
    let _this = this;
    this.hideNotificationTimer = setTimeout(() => {
      _this.props.hideNotification()
    }, 250);
  }
  render() {
    return (
      <div className={"alertChatComponent onResponse " + (this.state.hiddeAlert ? "hidden" : "")}>
        <div className="marginLeft yellow"></div>
        <div className="iconAlertMessage">
          <img className="imgWarning" src={alert} alt="icon"></img>
        </div>
        <div className="infoAlertMessage onResponse">
          <p className="titleAlertMessage">{this.language.getText("GUIAlertVolumewarning")}</p>
          <p className="textAlertMessage onResponse">{this.language.getText("GUIAlertVolumecontent")}</p>
        </div>
      </div>
    );
  }
}


// WEBPACK FOOTER //
// ./src/components/Alerts/AlertMessageVolume.jsx